module.exports = __webpack_public_path__ + "static/beauty8-ff16470513f4049ac1f4a69213012849.jpg";